import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { VesselService } from 'src/app/_service/vessel.service';
import { AuthService } from 'src/app/_service/auth.service';
import * as routing from '../../../_model/routing';
import { CompanyService } from 'src/app/_service/company.service';

@Component({
  selector: 'app-vessel-detail',
  templateUrl: './vessel-detail.component.html',
  styleUrls: ['./vessel-detail.component.css']
})
export class VesselDetailComponent implements OnInit {
  @Output() dataChange = new EventEmitter();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private companyService: CompanyService,
    private vesselService: VesselService,
    public auth: AuthService,
  ) { }

  vesselID = '';
  vesselData: any = null;
  applicationID = '';

  ngOnInit(): void {
    const vesselId = this.route.snapshot.paramMap.get('id');
    if (!vesselId) {
      this.goBackList();
      return;
    }

    this.vesselID = vesselId;
    this.vesselService.selectedVesselID = vesselId;

    this.vesselService.getVesselById(vesselId).subscribe({
      next: (data: any) => {
        this.vesselData = data;
      },
      error: () => {
        window.alert('Unable to load vessel details.');
        this.goBackList();
      }
    });
  }

  editVesselData() {
    if (this.auth.isYakuin) {
      window.alert('You do not have permission to edit this vessel.');
      return;
    }
    this.vesselService.editVesselFlag = true;
    this.vesselService.editVesselData = this.vesselData;
    this.router.navigate([routing.VesselRegister]);
  }

  editVesselApplication() {
    if (this.auth.isYakuin) {
      window.alert('You do not have permission to edit this vessel application.');
      return;
    }
    this.router.navigate([routing.VesselApplicationRegister, { vesselID: this.vesselID, applicationID: this.applicationID }]);
  }

  deleteVesselData() {
    if (this.auth.isYakuin) {
      window.alert('You do not have permission to delete this vessel.');
      return;
    }

    if (window.confirm('Can I delete this Vessel Data?')) {
      this.vesselService.deleteVesselData()
        .subscribe({
          complete: () => {
            this.dataChange.emit();
          },
          error: () => {
            window.alert('Error occurred while deleting this vessel.');
          }
        });
    }
  }

  goBackList() {
    this.location.back();
  }
}
